var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backButton",on:{"click":function($event){return _vm.emitEvent('click')}}},[_c('b-icon',{attrs:{"scale":"2","icon":"chevron-left"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }